module.exports = __webpack_public_path__ + "static/media/ahmedzona.6ceed120.png";